export default __webpack_public_path__ + "static/media/plin.c1fc7716.png";